import { handleEntriesTopBranches } from "../../../api/entries";
import { ShopOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import AllEntries from "./AllEntries";

export default function Branches({ filters }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const [title, setTitle] = useState<any>("Branch");
  const params = `startDate=${filters?.startDate}&endDate=${filters?.endDate}&branch=${filters?.branch}`;
  const { data: branches } = useQuery({
    queryKey: ["topBranches", params],
    queryFn: () => handleEntriesTopBranches({ params }),
  });
  return (
    <div className="col-span-6">
      <div className="grid grid-cols-12 gap-x-1">
        {branches?.map((item: any, index: number) => (
          <button
            key={index}
            onClick={() => {
              setTitle(item?.name);
              setSelected(item);
              setVisible(true);
            }}
            className="col-span-4 p-2 w-full  border border-gray-300 shadow-sm bg-blue-50"
          >
            <div className="flex">
              <div className="text-lg">
                <ShopOutlined />
              </div>

              <div className="flex flex-col items-start text-gray-500 mx-2">
                <div className="font-bold text-black">{item?.name} Branch</div>
                <div className="flex justify-start">
                  <span className="font-bold mr-1">{item?.totalEntries}</span>{" "}
                  <span className="text-gray-400">Entries</span>
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>

      {isVisible && (
        <AllEntries
          isVisible={isVisible}
          setVisible={setVisible}
          title={title}
          branchId={selected?._id}
          startDate={filters?.startDate}
          endDate={filters?.endDate}
        />
      )}
    </div>
  );
}
